import { createRouter,createWebHashHistory } from "vue-router"
import store from '@/store' // 引入状态管理（需自行创建）

//创建路由器
const routes = [  //一个一个的路由规则
  {
    path: '/',
    name: 'WebLogin',
    component: () => import("../views/WebLogin.vue"),
    meta: { 
      title: '唐山安居微信小程序管理平台',
      // 登录页不需要权限
      requiresAuth: false 
    }
  },
  {
    path: '/WebMain',
    name: 'WebMain',
    component: () => import("../views/WebMain.vue"),
    // 重定向，自动跳转到指定路由
    redirect: "/HomePage",
    meta: {
      requiresAuth: true, // 需要登录
      roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
    },
    //嵌套路由
    children: [
      {
          path: '/HomePage',
          name: '系统主页', 
          component: () => import("@/views/HomePage"),
          meta: {
            requiresAuth: true, // 需要登录
            roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
          },
      },
      {
          path: '/CustomerManager',
          name: '客户信息管理', 
          component: () => import("@/views/CustomerManager"),
          meta: {
            requiresAuth: true, // 需要登录
            roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
          },
      },
      {
          path: '/ShortcutLogManager',
          name: '客户足迹管理', 
          component: () => import("@/views/ShortcutLogManager"),
          meta: {
            requiresAuth: true, // 需要登录
            roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
          },
      },
      {
        path: '/ShortcutManager',
        name: '快捷功能管理', 
        component: () => import("@/views/ShortcutManager"),
        meta: {
          requiresAuth: true, // 需要登录
          roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
        },
      },
      {
        path: '/MessageManager',
        name: '系统通知管理', 
        component: () => import("@/views/MessageManager"),
        meta: {
          requiresAuth: true, // 需要登录
          roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
        },
      },
      {
        path: '/BannerManager',
        name: '专题推荐管理', 
        component: () => import("@/views/BannerManager"),
        meta: {
          requiresAuth: true, // 需要登录
          roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
        },
      },
      {
        path: '/RecommendManager',
        name: '为你精选管理', 
        component: () => import("@/views/RecommendManager"),
        meta: {
          requiresAuth: true, // 需要登录
          roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
        },
      },
      {
        path: '/NewsManager',
        name: '发现精彩管理', 
        component: () => import("@/views/NewsManager"),
        meta: {
          requiresAuth: true, // 需要登录
          roles: ['admin', 'editor'] // 所有角色都能访问主框架 0：管理员，1：普通用户
        },
      },
      {
          path: '/UserManager',
          name: '用户管理', 
          component: () => import("@/views/UserManager"),
          meta: {
            requiresAuth: true, // 需要登录
            roles: ['admin'] // 所有角色都能访问主框架 0：管理员，1：普通用户
          },
      },
      {
          path: '/ConfigManager',
          name: '配置管理', 
          component: () => import("@/views/ConfigManager"),
          meta: {
            requiresAuth: true, // 需要登录
            roles: ['admin'] // 所有角色都能访问主框架 0：管理员，1：普通用户
          },
      }
    ]
  }
];
const router = createRouter({
  mode: 'hash', //history hash
  // history: createWebHistory(),
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

// 路由守卫：控制权限访问
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 不需要登录的页面直接放行
  if (!to.meta.requiresAuth) {
    return next()
  }
  // 检查角色权限
  const userRole = store.state.role // 用户角色存储在store中
  // 检查当前路由是否需要特定角色
  if (to.meta.roles && to.meta.roles.includes(userRole)) {
    next() // 有权限，放行
  } else {
    next('/') // 无权限，跳转到登录页面
  }
})

export default router